import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

// Components
import { Col, List, Row, Form, Flex, message } from "antd";
import {
  CustomImage,
  CustomInput,
  CustomTitle,
  CustomButton,
} from "../../components";
import { LinkSensorsAccount } from "../../api's/onboarding";
import { useToken } from "../../common/helper";
import { useSpin } from "../../components/SpinContext";


const data = [
  {
    title: "Go to",
    isLink: true,
    linkText: "",
    href: "",
  },
  { title: "Click “Add new credentials” (top right)" },
  { title: "Input in Client ID: zoomlogi" },
  { title: "Checkbox for “Authorize all current and future accounts”" },
  { title: "Click “Generate Credentials”" },
];

const SensorConnectionModal = ({ closeModal, id, onSuccess, sensorData }) => {
  const [form] = Form.useForm();
  const [isFormValid, setIsFormValid] = useState(false);
  const [sensorId, setSensorsId] = useState(null);
  const { token, removeToken } = useToken();
  const { showSpin, hideSpin } = useSpin();
  const navigate = useNavigate();
  const [description, setDescription] = useState(data);
  const [sensorImg, setSensorImg] = useState();
  const [sensorModal, setSensorModal] = useState([
    "Client ID",
    "Client Secret",
  ]);

  useEffect(() => {
    if (id) {
      setSensorsId(id);
    }
  }, [id]);

  useEffect(() => {
      form.resetFields();
      setSensorModal(["Client ID", "Client Secret"]);
  }, [sensorData]);
  

  useEffect(() => {
    if (sensorData) {
      if (sensorData?.image) {
        setSensorImg(sensorData.image);
      }
      if (sensorData?.credential_description) {
        setDescription(sensorData?.credential_description);
      }
      if (
        sensorData?.required_inputs &&
        Array.isArray(sensorData?.required_inputs)
      ) {
        let arr = sensorData?.required_inputs;
        setSensorModal(arr);
      }
      form.setFieldsValue(sensorData?.credential);
    }
  }, [sensorData]);

  const unauthorize = (error) => {
    if (error && error?.status === 401) {
      removeToken();
      navigate("/login");
    }
  };

  const handleCancel = () => {
    closeModal();
  };

  const LinkSensors = (model) => {
    onSuccess(model);
    // setIsFormValid(true);
    // showSpin();
    // LinkSensorsAccount(token, model)
    //   .then((res) => {
    //     const data = res?.data || null;
    //     if (data) {
    //       if (data?.data?.is_success) {
    //         onSuccess();
    //         message.success(data?.data?.message);
    //         closeModal();
    //       } else {
    //         message.error(data?.data?.message);
    //       }
    //     }
    //   })
    //   .catch((err) => {
    //     unauthorize(err);
    //   })
    //   .finally(() => {
    //     hideSpin();
    //     setIsFormValid(false);
    //   });
  };

  const onFinishForm = (values) => {
    if (values 
      // && Object.keys(values).length > 0
    ) {
      //let model = form.getFieldsValue();
      let model = {
        // sensor_id: sensorId,
        credentials: { ...values },
      };
      //model.sensor_id = sensorId;
      LinkSensors(model);
    }
  };

  return (
    <Form
      form={form}
      name="validateOnly"
      initialValues={{
        client_id: "",
        client_secret: "", 
      }}
      layout="vertical"
      labelCol={{
        span: 8,
      }}
      wrapperCol={{
        span: 24,
      }}
      autoComplete="off"
      onFinish={onFinishForm}
    >
      <Row gutter={12}>
        <Col span={24}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "12px",
            }}
          >
            <div style={{ paddingLeft: "6px" }}>
              <CustomTitle
                text="Instructions"
                fontSize="14px"
                fontWeight="600"
                color="black"
              />
              <List
                split={false}
                itemLayout="horizontal"
                dataSource={description}
                renderItem={(item, index) => (
                  <List.Item style={{ padding: "0" }}>
                    <List.Item.Meta
                      title={
                        item.isLink ? (
                          <>
                            <span style={{ fontWeight: 400 }}>
                              {index + 1}. {item.title}{" "}
                            </span>
                            <a
                              href={item?.href}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{
                                textDecoration: "underline",
                                fontWeight: 400,
                              }}
                            >
                              {item.linkText}
                            </a>
                          </>
                        ) : (
                          <span style={{ fontWeight: 400 }}>
                            {index + 1}. {item?.title}
                          </span>
                        )
                      }
                    />
                  </List.Item>
                )}
              />
            </div>
            <Col xxl={12} xl={12} lg={16} md={24} sm={24} xs={24}>
              {sensorModal.map((element) => (
                <Form.Item
                  label={element}
                  name={element}
                  className="custom-input form-input-style"
                  style={{ paddingTop: "12px" }}
                  labelCol={{ width: "100%" }}
                  rules={[
                    {
                      required: true,
                      message: `Please input ${element ? element : "value"}`,
                    },
                  ]}
                >
                  <CustomInput
                    placeholder={`Paste ${element ? element : "value"} here`}
                    height="36px"
                    width="100%"
                    border="0px"
                    bgColor="#F3F3F3"
                    textColor="#5E5E5E"
                    borderRadius="8px"
                    placeholderColor="#5E5E5E"
                    lineHeight="38px"
                    // suffix={<img src={shield} alt="shield" />}
                  />
                </Form.Item>
              ))}
            </Col>
          </div>
        </Col>
      </Row>
      <React.Fragment key="footer-actions">
        <Flex gap="16px" justify="end" style={{ marginTop: "32px" }}>
          <CustomButton
            key="button1"
            onClick={handleCancel}
            text={"I'll do this later"}
            bgColor="transparent"
            color="black"
            fontSize="14px"
            fontWeight="600"
            boxShadow="none"
            height="48px"
          />
          <CustomButton
            key="button2"
            text={"Confirm"}
            bgColor="black"
            color="white"
            height="48px"
            width="100px"
            fontSize="14px"
            fontWeight="600"
            boxShadow="none"
            borderRadius="8px"
            isFormValid={isFormValid}
            htmlType="submit"
          />
        </Flex>
      </React.Fragment>
    </Form>
  );
};

export default SensorConnectionModal;
